import { colSize_t, offsetSize_t, tabletColSize_t } from '../../UI/Grid';
import {
    PrismicTitleFieldType,
    PrismicRichTextFieldType,
    PrismicLinkFieldType,
    SliceContext,
    PrismicImageField,
    PrismicFluidImageField,
} from '../types';
import { SupportedPrismicSlicesEnum } from '../enums';

export enum Positions {
    Left = 'Left',
    Right = 'Right',
    Center = 'Center',
}

export type PositionsStyles = {
    flexDirection: string;
    leftColSize: colSize_t;
    leftColOffset: offsetSize_t;
    rightColSize: colSize_t;
    rightColOffset: offsetSize_t;
    r_tabletColSize: tabletColSize_t;
};

export type FeatureProps = {
    slice: {
        type: SupportedPrismicSlicesEnum.feature;
        primary: {
            feature_title: PrismicTitleFieldType;
            feature_position: Positions;
            feature_description: PrismicRichTextFieldType;
            feature_cta_label: PrismicTitleFieldType;
            feature_cta_link: PrismicLinkFieldType;
            feature_image: PrismicImageField;
            feature_imageSharp: PrismicFluidImageField;
            feature_image_cta_link: PrismicLinkFieldType;
        };
    };
    sliceContext: SliceContext;
};
